export default "__VITE_ASSET__Htl73qf9__"